import type { FC } from "react";
import {
  checkAlpharunOperatedIntegrationEnabled,
  useAlpharunOperatedIntegrationDetailOutletContext,
} from "./alpharunOperatedIntegrationDetailSection.js";

/**
 * The Settings tab of an Alpharun-operated integration. Nothing is editable or
 * shown beyond the pause state: Alpharun holds the credentials and agent list
 * and changes them on request.
 */
export const AlpharunOperatedIntegrationSettingsTab: FC = () => {
  const { integration, config } =
    useAlpharunOperatedIntegrationDetailOutletContext();

  return (
    <div className="max-w-3xl space-y-6">
      <p className="text-sm leading-6 text-muted-foreground">
        {config.description}
      </p>

      {!checkAlpharunOperatedIntegrationEnabled(integration) ? (
        <div className="rounded-md bg-amber-50 p-3 text-sm text-amber-800">
          Imports are currently paused by Alpharun.
        </div>
      ) : null}

      <p className="text-sm leading-6 text-muted-foreground">
        This integration is managed by Alpharun. To change which agents are
        imported or update your {config.name} credentials, contact your Alpharun
        team.
      </p>
    </div>
  );
};
